import {
    Box,
    Flex,
    Text,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Button,
    useDisclosure,
    useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import Navbar from "../Components/Navbar/Navbar";
import Sidebar from "../Components/Sidebar";
import BannerManager from "../Components/Frontend/BannerManager";
import FeaturedSectionManager from "../Components/Frontend/FeaturedSectionManager";
import SocialLinksManager from "../Components/Frontend/SocialLinksManager";
import { FiPlus } from "react-icons/fi";

const SIDEBAR_WIDTH = "240px";

export default function FrontendSettings() {
    const toast = useToast();
    const [activeTab, setActiveTab] = useState(0);

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="#f8f9fd"
                minH="100vh"
                mt="80px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                <Flex justify="space-between" align="center" mb={6}>
                    <Box>
                        <Text fontSize="2xl" fontWeight="700" color="#344767">
                            Frontend Settings
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                            Manage banners, featured game sections, and social links for jskbook.
                        </Text>
                    </Box>
                </Flex>

                <Box bg="white" borderRadius="12px" boxShadow="sm" p={4} border="1px solid #f0f2f5">
                    <Tabs variant="enclosed" colorScheme="blue" onChange={(index) => setActiveTab(index)}>
                        <TabList>
                            <Tab fontWeight="600">Banners</Tab>
                            <Tab fontWeight="600">Featured Games</Tab>
                            <Tab fontWeight="600">Social Links</Tab>
                        </TabList>

                        <TabPanels>
                            <TabPanel>
                                <BannerManager />
                            </TabPanel>
                            <TabPanel>
                                <FeaturedSectionManager />
                            </TabPanel>
                            <TabPanel>
                                <SocialLinksManager />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Box>
            </Box>
        </>
    );
}
